import ApiPermisos from './../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    refresh: true,
    sites: [],
    societies: [],
    processes: [],
    states: [],
    processLineChartdatacollection: {
      labels: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      datasets: [
        {
          label: "Procesos",
          backgroundColor: "#4F656E",
          borderColor: "#4F656E",
          fill: true,
          data: [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
          ],
        },
      ],
    },
  },
  getters: {

  },
  mutations: {
    setRefresh: (state, refresh) => {
      state.refresh = refresh;
    },
    setSites: (state, sites) => {
      state.sites = sites;
    },
    setSocieties: (state, societies) => {
      state.societies = societies;
    },
    setStates: (state, states) => {
      state.states = states;
    },
    setProcesses: (state, processes) => {
      state.processes = processes;

      let tmp = state.processLineChartdatacollection;
      tmp.datasets[0].data =  [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
      ];

      for (let i = 0; i < processes.length; i++) {
        tmp.datasets[0].data[(processes[i].month * 1) - 1] = processes[i].total;
      }
      state.processLineChartdatacollection = tmp;
    },
  },
  actions: {
    actGetSites: ({
      commit,
    },) => {
      ApiPermisos.getProceDashboard({
        model: 'sites',
      }).then((response) => {
        commit('setSites', response.data);
      })
    },
    actGetSocieties: ({
      commit,
    },) => {
      ApiPermisos.getProceDashboard({
        model: 'societies', 
      }).then((response) => {
        commit('setSocieties', response.data);
      })
    },
    actGetStates: ({
      commit,
    },) => {
      ApiPermisos.getProceDashboard({
        model: 'states', 
      }).then((response) => {
        commit('setStates', response.data);
      })
    },
    actGetProcesses: ({
      commit,
    }, data) => {
      ApiPermisos.postProceDashboard({
        model: 'processes', 
        data: data,
      }).then((response) => {
        commit('setProcesses', response.data);
        commit('setRefresh', true);
      })
    },
  },
}